export const COLLECTING_DATA_TOOLTIP =
  'Still collecting data — needs at least 5 days and 5,000 users per variant before a verdict is possible.';

export function formatPercent(value: number, decimals = 2): string {
  return `${value.toFixed(decimals)}%`;
}

export function formatSignedPercent(value: number, decimals = 2): string {
  const rounded = Number(value.toFixed(decimals));
  return `${rounded >= 0 ? '+' : ''}${rounded.toFixed(decimals)}%`;
}

export function formatCurrency(value: number, decimals = 2): string {
  return `$${value.toLocaleString(undefined, {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  })}`;
}

export function formatCompactNumber(value: number): string {
  if (value >= 1_000_000) return `${(value / 1_000_000).toFixed(1)}M`;
  if (value >= 1_000) return `${Math.round(value / 1_000)}k`;
  return value.toLocaleString();
}

export function getDeltaClassName(
  value: number,
  positiveClassName: string,
  negativeClassName: string,
  decimals = 2
): string {
  const rounded = Number(value.toFixed(decimals));
  return rounded >= 0 ? positiveClassName : negativeClassName;
}
